import { Directive, ElementRef, Input } from '@angular/core';
import { AriaElement } from '../aria-element.directive';

/**
 * direttiva da applicare sui componenti ion-button
 * che devono avere un'aria-label che cambia dinamicamente
 */
@Directive({
  selector: '[appAriaButton]'
})
export class AriaButtonDirective extends AriaElement<HTMLIonButtonElement> {
  constructor(protected el: ElementRef<HTMLIonButtonElement>) {
    super(el);

    this.adaptHidden = true;
  }

  @Input() set appAriaButton(label: string) {
    this.currentLabel = label;
    this.untillDone.do();
  }

  findElements(): HTMLElement[] {
    return [
      this.el.nativeElement,
      this.el.nativeElement.shadowRoot.querySelector('button')
    ];
  }
}
